export default (filePath) => {
  if (!filePath) {
    return;
  }
  const splitted = filePath.split('/');
  return splitted[splitted.length - 1].split('?')[0];
}


// WEBPACK FOOTER //
// ./src/helpers/get-file-name.js